import apiSlice from "./apiSlice";
const bulkUploadSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    bulkUpload: builder.mutation({
      query: ({ file, projectId }) => {
        const formData = new FormData();
        formData.append("file", file);
        if (projectId) {
          formData.append("projectId", projectId);
        }

        return {
          url: "/account/UploadUsers",
          method: "POST",
          body: formData,
        };
      },
    }),
    getBulkUploads: builder.query({
      query: (params) => ({
        url: "/BulkUpload",
        params,
      }),
    }),
    getBulkUploadDetails: builder.query({
      query: (fileId) => ({
        url: `/BulkUpload/${fileId}`,
      }),
    }),
  }),
});

export const {
  useBulkUploadMutation,
  useGetBulkUploadsQuery,
  useGetBulkUploadDetailsQuery,
} = bulkUploadSlice;
